import { subDays } from 'date-fns';
import { format } from 'date-fns/format';
import { useState } from 'react';
import { useDeleteAgendaSlotRecurrenceForm } from '@/components/forms/delete-agenda-slot-recurrence/use-delete-agenda-slot-recurrence-form';
import useDeleteOccurrenceAgendaSlotMutation, {
  DeleteOccurrenceAgendaSlotResponse,
} from '@/hooks/mutations/use-delete-occurrence-agenda-slot';
import useStopRecurrenceAgendaSlotMutation, {
  StopRecurrenceAgendaSlotResponse,
} from '@/hooks/mutations/use-stop-recurrence-agenda-slot';
import { popModal } from '..';

export type DeleteAgendaSlotRecurrenceModalApi = {
  onDeleteOccurenceSuccess: ({
    data,
  }: {
    data: DeleteOccurrenceAgendaSlotResponse;
  }) => void;
  onStopSeriesSuccess: ({
    data,
  }: {
    data: StopRecurrenceAgendaSlotResponse;
  }) => void;
  onClose?: (props?: { deleted: boolean }) => void;
  onCancel?: () => void;
};
export type DeleteAgeandaSlotEventOccurence = {
  id: string | null;
  allday: boolean;
  start: Date;
  end: Date | null;
  index: number;
};
export const selectDeleteAgendaSlotRecurrenceViewModel = ({
  slotId,
  api,
  eventOccurrence,
}: {
  slotId: string;
  api: DeleteAgendaSlotRecurrenceModalApi;
  eventOccurrence: DeleteAgeandaSlotEventOccurence;
}) => {
  const [show, setShow] = useState<boolean>(true);
  const { deleteAgendaSlotRecurrenceForm } =
    useDeleteAgendaSlotRecurrenceForm();

  const {
    mutate: deleteOccurenceAgendaSlotMutation,
    isPending: isDeleteOccurrenceLoading,
  } = useDeleteOccurrenceAgendaSlotMutation();

  const {
    mutate: stopRecurrenceAgendaSlot,
    isPending: isStopRecurrenceAgendaSlotLoading,
  } = useStopRecurrenceAgendaSlotMutation();

  const closeModal = (props?: { deleted: boolean }) => {
    setShow(false);
    popModal('DeleteAgendaSlotRecurrenceModal');
    api.onClose?.(props);
  };

  const cancelModal = () => {
    setShow(false);
    popModal('DeleteAgendaSlotRecurrenceModal');
    api.onCancel?.();
  };

  const submitDeleteOccurrence = () => {
    deleteOccurenceAgendaSlotMutation(
      {
        id: slotId,
        exdate: eventOccurrence.allday
          ? format(eventOccurrence.start, 'yyyy-MM-dd')
          : eventOccurrence.start.toISOString(),
      },
      {
        onSuccess(deleteOccurenceAgendaSlotResponse) {
          api.onDeleteOccurenceSuccess({
            data: deleteOccurenceAgendaSlotResponse,
          });

          closeModal({ deleted: true });
        },
      },
    );
  };
  const submitStopSeries = () => {
    const untilDate = subDays(eventOccurrence.start, 1);
    stopRecurrenceAgendaSlot(
      {
        id: slotId,
        until: eventOccurrence.allday
          ? format(untilDate, 'yyyy-MM-dd')
          : untilDate.toISOString(),
        occurrenceIndex: eventOccurrence.index,
      },
      {
        onSuccess(stopRecurrenceAgendaSlotResponse) {
          api.onStopSeriesSuccess({
            data: stopRecurrenceAgendaSlotResponse,
          });

          closeModal({ deleted: true });
        },
      },
    );
  };

  return {
    api: {
      submit: () => {
        const { mode: selectedDeleteMode } =
          deleteAgendaSlotRecurrenceForm.getValues();

        if (selectedDeleteMode === 'delete-occurrence') {
          return submitDeleteOccurrence();
        } else if (selectedDeleteMode === 'stop-recurrence') {
          return submitStopSeries();
        }
      },
      close: closeModal,
      cancel: cancelModal,
    },
    data: {
      show,
      deleting: isDeleteOccurrenceLoading || isStopRecurrenceAgendaSlotLoading,
      form: deleteAgendaSlotRecurrenceForm,
    },
  };
};
